import { render, staticRenderFns } from "./StepRestricoes.vue?vue&type=template&id=fe81ed06&scoped=true"
import script from "./StepRestricoes.vue?vue&type=script&lang=js"
export * from "./StepRestricoes.vue?vue&type=script&lang=js"
import style0 from "./StepRestricoes.vue?vue&type=style&index=0&id=fe81ed06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe81ed06",
  null
  
)

export default component.exports